module.exports = __webpack_public_path__ + "static/media/argon-react-white.ba6e5978.png";